export const mapToServiceFilter = ({
  contextFilter,
  billingTransactionFilter,
  consolidatedTypeFilter,
  isOverdue,
  dueDate,
  billStatus
}) => ({
  projectUri: contextFilter.projectUri,
  clientUris: contextFilter.clientUri
    ? [contextFilter.clientUri]
    : billingTransactionFilter.clients,
  programUri: contextFilter.programUri,
  dateRange: billingTransactionFilter.dateRange,
  searchTerm: billingTransactionFilter.searchTerm,
  transactionTypes: consolidatedTypeFilter,
  balanceStatusList: billStatus ? null : ['UNALLOCATED', 'PARTIALLY_ALLOCATED'],
  isOverdue,
  dueDate,
  billStatus
});

export const getConsolidatedTypeFilter = (
  transactionTypes,
  summaryTransactionType
) =>
  (transactionTypes || []).filter(
    z => summaryTransactionType.indexOf(z) !== -1
  );
